import DataGrid from "devextreme/ui/data_grid";

DataGrid.defaultOptions({
    options: {
        rowAlternationEnabled: true
    }
});